import { logViewClose, logViewOpen } from '../api/rpc';
import { geo } from './geo';

/**
 * 詳細を開いた記録（研究の主分析の材料）。開いた時刻は端末の時刻を測位を待たずに取る（合宿版の対策）。
 * 通信に失敗しても画面は止めない。
 */
export async function openView(kind: 'spot' | 'prompt', targetId: number, from: 'map' | 'book' | 'prompts'): Promise<(reason?: string) => void> {
  const openedAt = new Date().toISOString();
  const f = geo.fresh();
  let viewId: number | null = null;
  try {
    viewId = await logViewOpen({
      targetKind: kind,
      targetId,
      clientOpenedAt: openedAt,
      lat: f?.lat ?? null,
      lon: f?.lon ?? null,
      acc: f?.acc ?? null,
      openedFrom: from,
    });
  } catch {
    /* 記録できなくても続ける */
  }
  let closed = false;
  return (reason = 'close') => {
    if (closed || viewId === null) return;
    closed = true;
    void logViewClose({ viewId, clientClosedAt: new Date().toISOString(), reason }).catch(() => undefined);
  };
}
